import { useState, useEffect } from 'react';
import { getQueryInfos } from '../../services/front_api';
import { AppNameFromID } from '../../services/apps';
import AirdnaFilters from '../../widgets/AirdnaFilters';
import FvtFilters from '../../widgets/FvtFilters';

export default function FilterChooser({ query, category, storageKey }) {
    const activeApp = localStorage.getItem('active_app');
    const appNames = AppNameFromID();

    const [app, setApp] = useState(appNames[activeApp] || null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const targetKey = storageKey || query;

    console.log("FilterChooser query:", query);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getQueryInfos(query, category, activeApp);
                if (!data) {
                    setError(new Error('Page not found'));
                    return;
                }
                setApp(data.app);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (query) fetchData();
        else setLoading(false);

    }, [query, category, activeApp]);

    if (loading) return <div>Chargement...</div>;
    if (error) return <div>Erreur : {error.message}</div>;

    switch (app) {
        case "airdna":
            return <AirdnaFilters query={targetKey} app={app} />;
        case "fvt":
            return <FvtFilters query={targetKey} app={app} />;
        default:
            return <div>Aucune application sélectionnée ou filtres non disponibles.</div>;
    }
};
